import { make } from '@/app/make';

export function listen({notification}) {
    make('store').commit('notifications/addNewsNotifications', [notification]);
    make('store').commit('notifications/increaseCount');
}
